import React, { useState } from 'react';
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from 'react-responsive-carousel';
const HomeSlider = () => {
  return (
    <div className="container">
      <Carousel>
        <div>
          <img src="/assets/img/slider1.png" />
        </div>
        <div>
          <img src="/assets/img/Slider_1.jpg" />
        </div>
        <div>
          <img src="/assets/img/Slider_2.jpg" />
        </div>
      </Carousel>
    </div>
  )
}
export default HomeSlider;